module.exports = __webpack_public_path__ + "media/newstyle/images/50-countries-es-d501bddc8991de3d8815047bbea326ce.svg";